import React from 'react';
import AppointmentExitRedirect from './components/AppointmentExitRedirect';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import GptChat from './pages/chat/Chat';
import UserForm from "./pages/questionaire/UserForm";
import axios from "axios";
import VaccineRegistration from "./pages/registration/VaccineRegistration";
import AdminPanel from "./pages/admin/AdminPanel";
import VoiceCall from "./pages/voicecall/VoiceCall";

function App() {
    axios.defaults.withCredentials = true;

    return (
        <BrowserRouter basename="/">
            <AppointmentExitRedirect />
            <Routes>
                <Route path="/" element={<UserForm />} />
                <Route path="/selection-page" element={<Navigate to="/" replace />} />
                <Route path="/reservation" element={<VaccineRegistration />} />
                <Route path="/chat" element={<GptChat />} />
                <Route path="/chat/:vaccineName" element={<GptChat />} />
                <Route path="/admin" element={<AdminPanel />} />
                <Route path="/voicecall" element={<VoiceCall />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
